// https://github.com/streamich/react-use/blob/master/src/useBeforeUnload.ts
// Modified for issue: https://github.com/streamich/react-use/issues/1332
// Can be removed from our repo if PR get accepted
import { useCallback, useEffect } from "react";

export const useBeforeUnload = (enabled: () => boolean, message?: string | (() => string)) => {
	const handler = useCallback(
		(event: BeforeUnloadEvent): string | undefined => {
			if (!enabled()) return;

			event.preventDefault();

			const finalMessage = typeof message === "function" ? message() : message;

			if (finalMessage) {
				// eslint-disable-next-line @typescript-eslint/no-deprecated
				event.returnValue = finalMessage;
			}

			// eslint-disable-next-line consistent-return
			return finalMessage;
		},
		[enabled, message],
	);

	useEffect(() => {
		if (!enabled) {
			return;
		}

		window.addEventListener("beforeunload", handler);

		// eslint-disable-next-line consistent-return
		return () => window.removeEventListener("beforeunload", handler);
	}, [enabled, handler]);
};
